import React from 'react';
import { Card } from '@mui/material';
import MedicareSection from './MedicareSection';

/** Client > Clinical & Care > Medicare: the client's Medicare data shared through Ability Hub. */
function Medicare({ cust_details, user }) {
    return (
        <Card variant="outlined" style={{ borderRadius: '10px', borderColor: '#85C4E5', background: '#F9F9F9', height: '100%', display: 'flex', padding: 12, overflow: 'hidden' }}>
            <div style={{ flex: 1, minHeight: 0 }}>
                <MedicareSection
                    custEmail={cust_details?.cus_email}
                    userEmail={user?.sec_email}
                />
            </div>
        </Card>
    );
}

export default Medicare;
